import { range } from 'lodash-es';

export const NRX_ROUND_BY = 5;
export const NRX_GROUP_BREAKS = range(0, 351, NRX_ROUND_BY);
